import { type IComparisonAlbum } from '../repositories/property-comparison/entities/v1_get_comparison_albums/ComparisonAlbum';

export enum EComparisonAlbumsStatus {
  Initial = 'initial',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

export interface IComparisonAlbumsState {
  status: EComparisonAlbumsStatus;
  albums: IComparisonAlbum[];
}
